<template>
  <div class="product-recommendation product-recommendation-non-niche-items">
    <template v-if="productStore.productRecommendation?.nonNicheItems?.length">
      <h2 class="text--center">You May Also Like</h2>
      <ProductListSlider
        :products="productStore.productRecommendation.nonNicheItems"
        @item-click="trackingProductRecommendationClicked"
        :referer="PRODUCT_PAGE_NON_NICHE_ITEMS"
      />
    </template>
  </div>
</template>

<script lang="ts" setup>
import ProductListSlider from '@/components/product/ProductListSlider.vue'
import useProductStore from '@/store/product'
import {
  EVENT_TRACKING_PRODUCT_RECOMMENDATION_CLICKED,
  MIXPANEL_DESTINATION,
  destinationIntegrations,
  PRODUCT_PAGE_NON_NICHE_ITEMS,
} from '@/utils'
import Analytics from '@/services/analytics'

const productStore = useProductStore()

function trackingProductRecommendationClicked() {
  // const PRODUCT_COMPONENT = 'product_details'
  // Analytics.track(
  //   EVENT_TRACKING_PRODUCT_RECOMMENDATION_CLICKED,
  //   {
  //     component: PRODUCT_COMPONENT,
  //   },
  //   destinationIntegrations([MIXPANEL_DESTINATION])
  // )
}
</script>
